import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "@i18n/locales/en-EN/translation.json";
import translationFr from "@i18n/locales/fr-FR/translation.json";

const resources = {
  "en-EN": { translation: translationEn },
  "fr-FR": { translation: translationFr },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr-FR", // langue par défaut, sera écrasée par le store
  fallbackLng: "fr-FR",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
